import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 17 16",
  class: "th-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M12.191 13.333H8.858V9.96A6 6 0 0 0 14.19 4a5.8 5.8 0 0 0-.447-2.26.7.7 0 0 0-.146-.213l-.074-.054a.627.627 0 0 0-.327-.14H3.192a.6.6 0 0 0-.193.04q-.074.043-.14.094l-.08.06a.7.7 0 0 0-.147.213A5.8 5.8 0 0 0 2.191 4a6 6 0 0 0 5.333 5.96v3.373H4.191a.667.667 0 1 0 0 1.334h8a.667.667 0 1 0 0-1.334M3.524 4c0-.451.064-.9.194-1.333h8.946A4.666 4.666 0 1 1 3.524 4"
    }, null, -1)
  ]))]))
}
import { markRaw } from 'vue'
export default markRaw({ render: render })